import { render, staticRenderFns } from "./emoji-dialog.vue?vue&type=template&id=9ba02008&scoped=true&"
import script from "./emoji-dialog.vue?vue&type=script&lang=js&"
export * from "./emoji-dialog.vue?vue&type=script&lang=js&"
import style0 from "./emoji-dialog.vue?vue&type=style&index=0&id=9ba02008&lang=scss&scoped=true&"
import style1 from "./emoji-dialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba02008",
  null
  
)

export default component.exports